<template>
  <el-dialog :title="title[type]" width="60%" :visible="visible" :close-on-click-modal="false" @close="handleClose" append-to-body = "true">
    <el-upload multiple :show-file-list="false" :before-upload="handleBeforeUpload" :http-request="handleHttpRequest" :accept="handleUploadAccept()">
      <span v-if="accept" style="margin-right: 20px;">格式为 {{accept.join('、')}}</span>
      <el-button type="primary" size="small">上传素材</el-button>
    </el-upload>
    <div class="search-filter">
      <el-input @keyup.enter.native="clickFilterBtn" class="file-name" clearable size="small" placeholder="文件名称" suffix-icon="el-icon-search" v-model.trim="filter.name"></el-input>
      <el-cascader 
        class="tag-name"
        v-model.trim="filter.tag"
        :options="tagCascadeList"
        :props="tagOptionProps"
        @change="clickFilterBtn"
        :show-all-levels="false"
        clearable
        filterable
        size="small"
        placeholder="请输入或选择素材标签">
      </el-cascader>
      <el-button class="reset" size="small" plain @click="clickClearBtn">清除条件</el-button>
      <el-button class="search" size="small" plain @click="clickFilterBtn">立即筛选</el-button>
    </div>
    <div class="material-list" v-loading="listLoading">
      <ul v-if="this.list.length > 0" ref="listContainer">
        <li v-for="(item, index) in list" :key="item.id">
          <div class="preview click" @click="toggleSelectMaterial(index, item)">
            <img :src="getMaterialCoverSrc(item)" class="material-image"/>
            <div class="mask" v-show="item.selected">
              <div class="bg"></div>
              <div class="check">
                <div class="right"></div>
              </div>
            </div>
          </div>
          <div class="material-name" :title="item.name" @click="preview(item)">{{item.name}}</div>
        </li>
        <li v-for="item in fill" :key="item" class=""></li>
      </ul>
      <span v-else class="no-content click" @click="baseGetMaterialList()">暂无数据，点击刷新</span>
      <el-pagination style="text-align: right" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.currentPage"
        :page-sizes="[10, 50, 100, 200]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <span v-if="limit" style="float: left;" class="text">{{selectedMaterial.length}}/{{limit}}</span>
      <span v-else style="float: left;" class="text">已选择{{selectedMaterial.length}}个素材</span>
      <el-button style="margin-right: 10px" type="primary" @click="clickConfirmBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
/*
  Attribute:
    参数       说明                   类型       可选值                          默认值     必选
    type      素材类型               String    picture/video/audio/document                  是
    limit     用户选择的最大素材数   Number                                                  否
    accept    接受上传的素材后缀名    Array                                                  是
    visible   是否显示Dialog         Boolean                                     false       是

  Event:
    事件名称                说明                   回调参数
    confirm-select        确认选择素材后触发      materialList

  用法示例:
    <material-selector v-if="showMaterialSelector" :visible="showMaterialSelector" type="picture" :limit="5" :accept="['jpg', 'jpeg', 'png']">
    </material-selector>
*/
import { imageBase64ToUint8Array } from '@/util/util'
import { getMaterialList, addMaterial } from "@/api/material/material";
import { materialType, materialTypeList } from '@/const/crud/material/material'
import { getFileNameUUID, getOSSFileMaterial } from '@/api/basic/aliyunoss';
import { getTagRelationList } from '@/api/material/tag'
import uploadService from '@/common/common-logic/upload-service';

export default {
  name: "MaterialSelector",
  props: {
    // 素材类型
    type: {
      type: String,
      required: true,
    },
    // 素材最大选择个数(可选)
    limit: {
      type: Number,
      validator: function (value) {
        return value > 0;
      },
      required: false,
    },
    // 是否显示
    visible: {
      type: Boolean,
      required: true,
    },
    // 接受上传的素材类型
    accept: {
      type: Array,
      require: false
    }
  },
  data() {
    return {
      iconList: materialTypeList,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      sort: {
        sortField: 'inserted_time',
        sortPolicy: 'desc',
      },
      listLoading: true,
      list: [],
      // 选中的素材的id
      selectedMaterial: [],
      // 空白填充个数
      fill: 0,
      title: {
        picture: "图片素材",
        video: "视频素材",
        audio: "音频素材",
        document: "文档素材",
      },
      filter: {
        name: "",
        tag: [],
      },
      tagCascadeList: [],
      tagOptionProps:{
        value : 'id',
        label : 'tagName',
        children : 'tagList',
      },
    };
  },
  created: function () {
    this.iconList.forEach(item => item.src = require(`../../static/images/material/material_${icon.type}.svg`));
  },
  mounted: async function() {
    this.loadTagCascadeList();
    this.baseGetMaterialList();
    window.onresize = () => {
      this.calculateFillLength();
    };
  },
  methods: {
    async loadTagCascadeList() {
      const response = await getTagRelationList();
      this.tagCascadeList = response.data.data;
    },
    async baseGetMaterialList() {
      this.listLoading = true;
      const params = {};
      params.size = this.page.pageSize;
      params.current = this.page.currentPage;
      params.sortField = this.sort.sortField;
      params.sortPolicy = this.sort.sortPolicy;
      params.type = materialType[this.type.toUpperCase()];
      params.name = this.filter.name;
      var arr = this.filter.tag;
      params.tagId = arr[arr.length-1];

      const response = await getMaterialList(params);

      this.list = response.data.data.records;
      this.list.forEach((item) => {
        item.selected = this.selectedMaterial.findIndex(i => i.id === item.id) !== -1;
      });
      this.page.total = response.data.data.total;
      this.listLoading = false;
      this.calculateFillLength();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.baseGetMaterialList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.baseGetMaterialList();
    },
    toggleSelectMaterial(index, item) {
      let newItem = this.list[index];
      if (!newItem.selected) {
        // 判断是否超过限制
        if (this.limit) {
          // 已选择个数
          const selectedCount = this.selectedMaterial.length;
          if (selectedCount >= this.limit) {
            this.$message.warning('选择素材数不能超过最大个数')
            return;
          }
        }
        this.selectedMaterial.push(item);
      } else {
        this.selectedMaterial.splice(this.selectedMaterial.findIndex(i => i.id === item.id), 1);
      }
      newItem.selected = !newItem.selected;

      Vue.set(this.list, index, newItem);
    },
    calculateFillLength () {
      // 获取带有v-if渲染的容器的ref时，需要使用this.$nextTick.在下一次更新结束后操作
      this.$nextTick(() => {
        const containerWidth = this.$refs.listContainer.clientWidth;
        const total = this.list.length;
        // 每一行有几张素材
        const childContainerCountOfLine = Math.floor(containerWidth / 160);
        // 要填充几个空白
        const remainder = total % childContainerCountOfLine;
        this.fill = remainder === 0 ? 0 : (childContainerCountOfLine - remainder);
      });
    },
    clickClearBtn () {
      this.filter.name = '';
      this.filter.tag = [];
      this.page.currentPage = 1;
      this.baseGetMaterialList();
    },
    clickFilterBtn () {
      this.page.currentPage = 1;
      this.baseGetMaterialList();
    },
    clickConfirmBtn () {
      this.$emit('confirm-select', this.selectedMaterial);
    },
     handleBeforeUpload (file) {
      if (file.name.length > 45) {
        this.$message({
          type: 'info',
          duration: 0,
          showClose: true,
          message: `[${file.name}]名称过长，不能超过45个字符`
        })
        return false;
      }
      const type = materialType[this.type.toUpperCase()];
      if (type === materialType.PICTURE) {
        const fileType = file.type ? file.type.toLowerCase() : '';
        let tempList = fileType.split('/');
        let type = '';
        if (tempList.length > 0) {
          type = tempList[tempList.length - 1]
        }
        if (!this.accept.includes(type)) {
          this.$message({
            type: 'error',
            message: `[${file.name}]上传失败，图片素材上传仅支持${this.accept}格式`
          })
          return false;
        }
      }
      return true;
    },
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    async generatorVideoCoverImage(videoFile) {
      return new Promise((resolve, reject) => {
        let videoElement = document.createElement('video');
        const blob = new Blob([videoFile], {type: videoFile.type.toLowerCase()});
        const videoUrl = this.getObjectURL(blob);
        videoElement.setAttribute('x-webkit-airplay', '');
        videoElement.setAttribute('webkit-playsinline', '');
        videoElement.setAttribute('x5-playsinline', '');
        videoElement.setAttribute('playsinline', '');
        videoElement.setAttribute('x-webkit-airplay', '');
        videoElement.setAttribute('src', videoUrl);
        videoElement.muted = true;

        videoElement.addEventListener('loadeddata', async () => {
            const canvas = document.createElement('canvas');
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            canvas
              .getContext('2d')
              .drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            videoElement.setAttribute('src', null);
            window.URL.revokeObjectURL(videoUrl);
            videoElement = null;

            const b64Image = canvas.toDataURL('image/jpeg', 0.4);
            const u8Image = imageBase64ToUint8Array(b64Image);
            const key = `${getOSSFileMaterial() + getFileNameUUID()}.jpg`;
            const file = new Blob([u8Image], { type: 'image/jpg' });
            resolve({
              file,
              key,
            });
          }, { once: true }
        );

        videoElement.load();
        videoElement.play();
      });
    },
    async handleHttpRequest (data) {
      this.listLoading = true;
      try {
        const uploadFiles = [];
        const file = data.file;
        const fileKey = getOSSFileMaterial() + getFileNameUUID() + file.name.substr(file.name.lastIndexOf("."));

        const type = materialType[this.type.toUpperCase()];
        let coverKey = null;
        const contentKey = fileKey;

        if (type === materialType.VIDEO) {
          const coverImage = await this.generatorVideoCoverImage(file);
          uploadFiles.push({
            key: coverImage.key,
            file: coverImage.file,
          });
          coverKey = coverImage.key
        }

        uploadFiles.push({
          key: fileKey,
          file: file,
        });

        const material = {
          name: file.name,
          size: file.size,
          type: type,
        }

        const response = await uploadService.uploadFiles(uploadFiles);
        const contentFile = response.find(item => item.key === contentKey);
        material.contentUrl = contentFile.fileUrl;
        if (coverKey) {
          const coverImage = response.find(item => item.key === coverKey);
          material.coverUrl = coverImage.fileUrl;
        } else {
          material.coverUrl = material.contentUrl;
        }
        if (this.filter.tag) {
          const arr = this.filter.tag;
          material.tagId = arr[arr.length-1];
        }

        await addMaterial(material);
        this.listLoading = false;
        this.$message({
          type: 'success',
          message: `上传成功[${file.name}]`
        });
        this.page.currentPage = 1;
        this.baseGetMaterialList();
      } catch (error) {
        console.log(error);
        this.listLoading = false;
        this.$message({
          type: 'error',
          duration: 0,
          showClose: true,
          message: `上传失败，请重试[${file.name}]`
        })
      }
    },
     preview(item) {
       let url;
      if (item.type === materialType.PICTURE) {
        url = item.coverUrl;
      } else {
        url = item.contentUrl;
      }
      window.open(url);
    },
    getMaterialCoverSrc (item) {
      const type = materialType[this.type.toUpperCase()];
      let src;
      if (type === materialType.AUDIO || type === materialType.DOCUMENT) {
        src = this.iconList.find(item => item.value === type).src;
      } else {
        src = item.coverUrl;
      }
      return src;
    },
    handleUploadAccept () {
      if (this.accept) {
        return this.accept.map(item => '.' + item).join(',')
      }
      return '';
    },
    handleClose () {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.text {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  color: #606266;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  opacity: 1;
}
/deep/ .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}
.click {
  cursor: pointer;
}
.material-image {
  object-fit: contain;
}
.search-filter {
  display: flex;
  margin: 10px 0 10px 0;

  .file-name {
    width: 500px;
  }
  /deep/ .tag-name .el-input {
    margin-left: 8px;
    width: 250px;
  }

  .reset {
    margin-right: 8px;
  }
  
  .search {
    border-color: #5383f3;
    color: #5383f3;
  }

  .el-button+ .el-button {
    margin: 0px;
  }
}
.material-list {
  padding: 24px 20px 0 20px;
  height: auto;
  max-height: 442px;
  overflow-y: scroll;
  text-align: center;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb {
    max-height: 20px;
    border-radius: 20px;
    background-color: #dddddd;
  }
  .no-content {
    color: #909399;
  }
  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  li {
    position: relative;
    width: 160px;
    margin-bottom: 10px;
    .preview {
      position: relative;
      height: 160px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 2px;
      }
      .mask {
        .bg {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: #3b3b3b;
          opacity: 0.7;
        }
        .check {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: #5383f3;
          opacity: 1;
          .right {
            position: relative;
            left: 8px;
            top: 8px;
            width: 13px;
            height: 8px;
            border: 3px solid #ffffff;
            border-top: none;
            border-right: none;
            transform: rotate(-45deg);
          }
        }
      }
    }
    .material-name {
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      white-space: nowrap;
    }
  }
}
</style>
